import { render } from "./Articles.vue?vue&type=template&id=7a3d9ffd"
const script = {}

import "./Articles.vue?vue&type=style&index=0&id=7a3d9ffd&lang=scss"

import exportComponent from "/home/th3g3ntl3man/github/blog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__